import { render, staticRenderFns } from "./blue-whatsapp.vue?vue&type=template&id=64ce9dba&scoped=true"
import script from "./blue-whatsapp.vue?vue&type=script&lang=js"
export * from "./blue-whatsapp.vue?vue&type=script&lang=js"
import style0 from "./blue-whatsapp.vue?vue&type=style&index=0&id=64ce9dba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ce9dba",
  null
  
)

export default component.exports